import appInfo from "@common/appInfo";
import { IconAction } from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import classNames from "classnames";
import React from "react";

type Props = {
  hidden?: boolean;
  onClick: () => void;
};
export default ({ hidden, onClick }: Props) => (
  <IconAction
    isNoBackground
    className={classNames("ai_chat_toggle", {
      hidden: hidden,
      _theme_: appInfo.user?.isStaff || appInfo.user?.isSuperUser
    })}
    icon={IconType.Sparkles}
    isRound
    onClick={onClick}
    size={48}
  />
);
